import { NavigateFunction } from "react-router-dom";

let navigate: NavigateFunction;

export const setNavigate = (nav: NavigateFunction) => {
  navigate = nav;
};

export const getNavigate = () => {
  if (!navigate) {
    throw new Error("Navigate function is not set");
  }
  return navigate;
};
